import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import Root from './Root';
import './index.css';
import FontHandler from './src/Domain/Handlers/FontHandler';

/**
 * Application entrypoint for web.
 * Only add any platform dependant imports here.
 * @returns JSX Element.
 */
export default function App(): JSX.Element
{
  const [loaded, setLoaded] = useState(false);

  useEffect(() =>
  {
    (async (): Promise<void> =>
    {
      setLoaded(false);
      await FontHandler.initialise();
      setLoaded(true);
    })();
  }, []);

  if (!loaded)
  {
    return <View />;
  }

  return <Root />;
}
